import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';

import { Harvest } from '../shared/interfaces/harvest';
import { HarvestCrudService } from '../shared/services/harvest-crud.service';
import { TunaPiece } from '../shared/interfaces/tuna-piece';
import { TunaPieceCrudService } from '../shared/services/tuna-piece-crud.service';
import { CageCrudService } from 'src/app/shared/services/cage-crud.service';
import { Cage } from 'src/app/shared/interfaces/cage';
import { TunaPieceProcessCrudService } from '../shared/services/tuna-piece-process-crud.service';
import { TunaPieceProcess } from 'src/app/shared/interfaces/tuna-piece-process';
import { Fridge } from '../shared/interfaces/fridge';
import { FridgeCrudService } from '../shared/services/fridge-crud.service';
import { Client } from '../shared/interfaces/client';
import { ClientCrudService } from '../shared/services/client-crud.service';


@Component({
  selector: 'app-tuna-piece-process',
  templateUrl: './tuna-piece-process.component.html',
  styleUrls: ['./tuna-piece-process.component.scss']
})
export class TunaPieceProcessComponent implements OnInit {

  quantity : number = 0;
  fridgeKey : string = '';

  tunaPieces: Partial<TunaPiece>[];
  tunaPiecesNames: string[];
  tunaPiecesMap : Map<string,TunaPiece>;

  harvests: Partial<Harvest>[];
  harvestNames: string[];
  harvestsMap : Map<string,Harvest>;

  cages: Cage[];
  cagesNames: string[];
  cagesMap : Map<string,Cage>;

  tunaPieceProcesses: TunaPieceProcess[];
  tunaPieceProcess: TunaPieceProcess;
  selectedTunaPieceProcesses: TunaPieceProcess[] = [];
  //tunaPieceProcessMap : Map<string,TunaPieceProcess>;

  fridges: Partial<Fridge>[];
  fridgesMap : Map<string,Harvest>;

  clients: Partial<Client>[];
  clientsMap : Map<string,Client>;

  status: string[];
  markets: string[];

  tunaPieceProcessDialog: boolean = false;
  moveDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private harvestService : HarvestCrudService,
    private tunaPieceService : TunaPieceCrudService,
    private cageService : CageCrudService,
    private tunaPieceProcessService : TunaPieceProcessCrudService,
    private fridgeService : FridgeCrudService,
    private clientService : ClientCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Full tuna'},
      {label: 'Processes'}
    ];

    this.harvests = [];
    this.harvestNames = [];
    this.harvestsMap = new Map<string,Harvest>();

    this.tunaPieces = [];
    this.tunaPiecesNames = [];
    this.tunaPiecesMap = new Map<string,TunaPiece>();

    this.cages = [];
    this.cagesNames = [];
    this.cagesMap = new Map<string,Cage>();

    this.tunaPieceProcesses = [];
    this.tunaPieceProcess = { } as TunaPieceProcess ;

    this.fridges = [];
    this.fridgesMap = new Map<string,Fridge>();

    this.clients = [];
    this.clientsMap = new Map<string,Client>();

    this.status = [];
    this.status.push('Available');
    this.status.push('Disposal');
    this.status.push('Reserved');
    this.status.push('Sold');

    this.markets = [];
    this.markets.push('Local');
    this.markets.push('Overseas');
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let tp = this.tunaPieceProcessService.getList(); 
    tp.snapshotChanges().subscribe(data => {
      this.tunaPieceProcesses = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : TunaPieceProcess = jsonItem as TunaPieceProcess;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.tunaPieceProcesses.push(l);
        }
      })
    });

    let s = this.cageService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.cages = [];
      this.cagesNames = [];
      this.cagesMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Cage = jsonItem as Cage;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          let ll : Partial<Cage> = l;
            this.cages.push(l);
            this.cagesNames.push(l.name);
          this.cagesMap.set(ll.$key || 'na' , l);
        }
      })
    });

    let p = this.tunaPieceService.getList(); 
    p.snapshotChanges().subscribe(data => {
      this.tunaPieces = [];
      this.tunaPiecesNames = [];
      this.tunaPiecesMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : TunaPiece = jsonItem as TunaPiece;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<TunaPiece> = l;
          //delete ll.$key;
         // if (l.isEnabled ) {
            this.tunaPieces.push(ll);
            this.tunaPiecesNames.push(l.name);
         // }
          this.tunaPiecesMap.set(ll.$key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.tunaPieces = this.tunaPieces.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    let h = this.harvestService.getList(); 
    h.snapshotChanges().subscribe(data => {
      this.harvests = [];
      this.harvestNames = [];
      this.harvestsMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Harvest = jsonItem as Harvest;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Harvest> = l;
          //delete ll.$key;
         // if (l.isEnabled ) {
            this.harvests.push(ll);
            this.harvestNames.push(l.name);
         // }
          this.harvestsMap.set(ll.$key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.harvests = this.harvests.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    let f = this.fridgeService.getList(); 
    f.snapshotChanges().subscribe(data => {
      this.fridges = [];
      this.fridgesMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Harvest = jsonItem as Harvest;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Harvest> = l;
          //delete ll.$key;
         // if (l.isEnabled ) {
            this.fridges.push(ll);
         // }
          this.fridgesMap.set(ll.$key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.fridges = this.fridges.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);

     if (this.fridges && this.fridges.length > 0) {
      this.fridgeKey = this.fridges[0].$key || '';
     }

    });


    let c = this.clientService.getClientsList(); 
    c.snapshotChanges().subscribe(data => {
      this.clients = [];
      this.clientsMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Client = jsonItem as Client;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Client> = l;
          //delete ll.$key;
         // if (l.isEnabled ) {
            this.clients.push(ll);
         // }
          this.clientsMap.set(ll.$key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.clients = this.clients.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);

    //  if (this.clients && this.clients.length > 0) {
    //   this.clientKey = this.fridges[0].$key || '';
    //  }

    });

    // column management
    this.cols = [
      { field: 'qrcode', header: 'QRCode' },
      { field: 'name', header: 'Process Id' },
      { field: 'tunaPieceName', header: 'Tuna Piece' },
      { field: 'harvestName', header: 'Harvest' },
      { field: 'cageName', header: 'Cage' },

      { field: 'fishWeight', header: 'Fish Total Weight' },
      { field: 'fishAverageWeight', header: 'Fish Weight (avg)' },
      { field: 'fishNumber', header: 'Fish (nb)' },
      //{ field: 'fishMortality', header: 'Fish Mortality (nb / %)' },

      { field: 'fishLocation', header: 'Fish Location' },
      { field: 'fishStatus', header: 'Fish status' },

      { field: 'customerMarket', header: 'Market' },
      { field: 'customerName', header: 'Customer' },
      { field: 'customerUnitPrice', header: 'Unit price' },
      { field: 'customerIsInvoiced', header: 'IsInvoiced' },

      { field: 'description', header: 'Notes' },
      { field: 'tags', header: 'Tags' },

      
      
      // { field: 'filledAt', header: 'Filled at' },
      // { field: 'emptiedAt', header: 'Emptied at' },

      // { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.cageService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.cages);
            doc.save('tuna-processes.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.tunaPieceProcesses);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "tuna-processes");
    });
  }

  exportDTCSV() {
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field); });
      exportCols.push('position');
      this.exportService.exportToCsv(this.selectedTunaPieceProcesses, 'tuna-processes', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.tunaPieceProcess = {} as TunaPieceProcess;
    this.submitted = false;
    this.tunaPieceProcessDialog = true;
  }

  openMove(tunaPieceProcess: TunaPieceProcess) {
    this.tunaPieceProcess = tunaPieceProcess;
    this.submitted = false;
    this.moveDialog = true;
  }

  deleteSelectedTunaPieceProcesses() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected tuna record?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.tunaPieceProcesses = this.tunaPieceProcesses.filter(val => !this.selectedTunaPieceProcesses.includes(val));
            
            this.selectedTunaPieceProcesses.forEach( tunaPieceProcess => this.tunaPieceProcessService.delete(this.tunaPieceProcess.$key));
            this.selectedTunaPieceProcesses = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPieceProcessess Deleted', life: 3000});
        }
    });
  }

  editTunaPieceProcess(tunaPieceProcess: TunaPieceProcess) {
    this.tunaPieceProcess = {...tunaPieceProcess};
    this.tunaPieceProcessDialog = true;
  }

  deleteTunaPieceProcess(tunaPieceProcess: TunaPieceProcess) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + tunaPieceProcess.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.tunaPieceProcesses = this.tunaPieceProcesses.filter(val => val.$key !== tunaPieceProcess.$key);
            this.tunaPieceProcess = {} as TunaPieceProcess;
            this.tunaPieceProcessService.delete(tunaPieceProcess.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPieceProcess Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.tunaPieceProcessDialog = false;
    this.submitted = false;
  }

  hideMoveDialog() {
    this.moveDialog = false;
    this.submitted = false;
  }

  saveTunaPieceProcess() {
    this.submitted = true;

    if ( this.tunaPieceProcess.name.trim() ) {
      if (this.tunaPieceProcess.$key) {
          this.tunaPieceProcesses[this.findIndexById(this.tunaPieceProcess.$key)] = this.tunaPieceProcess;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPieceProcess Updated', life: 3000});
          this.tunaPieceProcessService.update(this.tunaPieceProcess);
        } else {
          this.tunaPieceProcess.position = this.tunaPieceProcesses.length;
          this.tunaPieceProcessService.add(this.tunaPieceProcess);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPieceProcess Created', life: 3000});
      this.tunaPieceProcesses = [...this.tunaPieceProcesses];
    }

    this.tunaPieceProcessDialog = false;
    this.tunaPieceProcess = { } as TunaPieceProcess;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.tunaPieceProcesses.length; i++) {
        if (this.tunaPieceProcesses[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeTunaPieceProcess(tunaPieceProcess : TunaPieceProcess) {
    console.log(tunaPieceProcess);
    console.log(this.harvests);
    this.tunaPieceProcessService.update(tunaPieceProcess);
  }

  completePosition(tunaPieceProcess : TunaPieceProcess) {
    if ( this.newPosition > -1 ) {
        tunaPieceProcess.position = this.newPosition;
        tunaPieceProcess = this.checkPositionLimits(tunaPieceProcess);
        this.reorderElements(tunaPieceProcess);
        //this.updateDB(tunaPieceProcess);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.tunaPieceProcesses);
    // const myClonedArray = [];
    // this.tunaPieceProcesses.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.tunaPieceProcesses.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.tunaPieceProcesses.length - 1 - event.dropIndex;
    const tunaPieceProcessToMove = this.tunaPieceProcesses[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.tunaPieceProcesses[index] = this.tunaPieceProcesses[index+1];
        this.tunaPieceProcesses[index].position = index;
        this.tunaPieceProcessService.update(this.tunaPieceProcesses[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.tunaPieceProcesses[index] = this.tunaPieceProcesses[index-1];
        this.tunaPieceProcesses[index].position = index;
        this.tunaPieceProcessService.update(this.tunaPieceProcesses[index]);
      }
    } 
    this.tunaPieceProcesses[endIndex] = tunaPieceProcessToMove;
    this.tunaPieceProcesses[endIndex].position = endIndex;
    this.tunaPieceProcessService.update(this.tunaPieceProcesses[endIndex]);
  }

  // onFieldEdit(tunaPieceProcess: Spray, fieldName: string): void {
  //   //console.log(this.tunaPieceProcesses);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + tunaPieceProcess[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       tunaPieceProcess.position = this.newPosition;
  //       tunaPieceProcess = this.checkPositionLimits(tunaPieceProcess);
  //       this.reorderElements(tunaPieceProcess);
  //       //this.updateDB(tunaPieceProcess);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(tunaPieceProcess);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.tunaPieceProcesses.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, tunaPieceProcess: TunaPieceProcess) {
    // console.log("event" +event);
    if (tunaPieceProcess.position != null && tunaPieceProcess.position > -1) {
      this.previousPosition = tunaPieceProcess.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(tunaPieceProcess: TunaPieceProcess) {
    console.log('check ',tunaPieceProcess.position + ' ' + this.tunaPieceProcesses.length);
    if (!tunaPieceProcess.position) {
     // console.log('check 1');
      return this.tunaPieceProcess;
    }
    if (tunaPieceProcess.position < 0) {
      tunaPieceProcess.position = 0;
      // console.log('check 2');
      return tunaPieceProcess;
    }
    if (tunaPieceProcess.position > this.tunaPieceProcesses.length) {
      tunaPieceProcess.position = this.tunaPieceProcesses.length - 1;
    //  console.log('check 3', tunaPieceProcess.position);
      return tunaPieceProcess;
    }
   // console.log('check 4');
    return tunaPieceProcess;
  }

  async reorderElements(tunaPieceProcess: TunaPieceProcess) {
    this.newPosition = this.newPosition  > this.tunaPieceProcesses.length ? this.tunaPieceProcesses.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === tunaPieceProcess.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const tunaPieceProcessToMove = this.tunaPieceProcesses[startIndex];
   // console.log('Item to move: ', this.tunaPieceProcesses[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.tunaPieceProcesses);
        console.log('Item to +1: ', this.tunaPieceProcesses[index+1]);

        this.tunaPieceProcesses[index] = this.tunaPieceProcesses[index+1];
        this.tunaPieceProcesses[index].position = index;
        // console.log('Move: ', this.tunaPieceProcesses[index+1]);
        // console.log('Move pos: ', this.tunaPieceProcesses[index].position);
        //await this.updateDB(this.tunaPieceProcesses[index]);
        this.tunaPieceProcessService.update(this.tunaPieceProcesses[index]);
     //   console.log('Update DB: ', this.tunaPieceProcesses[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.tunaPieceProcesses[index] = this.tunaPieceProcesses[index-1];
        this.tunaPieceProcesses[index].position = index;
        this.tunaPieceProcessService.update(this.tunaPieceProcesses[index]);
      }
    } 
    this.tunaPieceProcesses[endIndex] = tunaPieceProcessToMove;
    this.tunaPieceProcesses[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.tunaPieceProcessService.update(this.tunaPieceProcesses[endIndex]);
    
    // const myClonedArray = [];
    // this.tunaPieceProcesses.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.tunaPieceProcesses = myClonedArray;
   // this.getAllRecords();
  }


  onSelect (event: any, tunaPieceProcess: TunaPieceProcess) {
    //this.completeBarrel(barrel);
  }

  onBlur(event: any, tunaPieceProcess: TunaPieceProcess) {
    this.completeTunaPieceProcess(tunaPieceProcess);
  }

  onClose(event: any, tunaPieceProcess: TunaPieceProcess) {
    this.completeTunaPieceProcess(tunaPieceProcess);
  }


  onChangeHarvest(tunaPieceProcess: TunaPieceProcess, tunaPieceProcessHarvestKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = tunaPieceProcessHarvestKey;
    console.log('new key wanted',  newKey);
    console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      console.log('save1 ');
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      console.log('save2 ');
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newHarvest = this.harvestsMap.get(newKey) || {} as Harvest;
      const newHarvestName = newHarvest.name;
        
      tunaPieceProcess.harvestKey = newKey;
      tunaPieceProcess.harvestName = newHarvestName;
      console.log('save3 ');
      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;

    }

    if (previousKey && !newKey) {
      tunaPieceProcess.harvestKey = '';
      tunaPieceProcess.harvestName = '';
      console.log('save4 ');
      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;
    }

    const newRegion = this.harvestsMap.get(newKey) || {} as Harvest;
    const newHarvestName = newRegion.name;
        
    tunaPieceProcess.harvestKey = newKey;
    tunaPieceProcess.harvestName = newHarvestName;
    this.tunaPieceProcessService.update(tunaPieceProcess);
    return true;
  }

  displayHarvestName(key : string): string {
    if (this.harvestsMap.has(key)) {
      return this.harvestsMap.get(key)?.name || '';
    }
    return '';
  }

  onChangeCage(tunaPieceProcess: TunaPieceProcess, tunaPieceProcessCageKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = tunaPieceProcessCageKey;
    console.log('new key wanted',  newKey);
    console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      console.log('save1 ');
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      console.log('save2 ');
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newCage = this.cagesMap.get(newKey) || {} as Cage;
      const newCageName = newCage.name;
        
      tunaPieceProcess.cageKey = newKey;
      tunaPieceProcess.cageName = newCageName;
      console.log('save3 ');
      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;

    }

    if (previousKey && !newKey) {
      tunaPieceProcess.cageKey = '';
      tunaPieceProcess.cageName = '';
      console.log('save4 ');
      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;
    }

    const newCage = this.cagesMap.get(newKey) || {} as Cage;
    const newCageName = newCage.name;
        
    tunaPieceProcess.cageKey = newKey;
    tunaPieceProcess.cageName = newCageName;
    this.tunaPieceProcessService.update(tunaPieceProcess);
    return true;
  }

  displayTunaPieceName(key : string): string {
    if (this.tunaPiecesMap.has(key)) {
      return this.tunaPiecesMap.get(key)?.name || '';
    }
    return '';
  }

  onChangeTunaPiece(tunaPieceProcess: TunaPieceProcess, tunaPieceProcessPieceKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = tunaPieceProcessPieceKey;
    // console.log('new key wanted',  newKey);
    // console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {

      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {

      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newTP = this.tunaPiecesMap.get(newKey) || {} as TunaPiece;
      const newTPName = newTP.name;
        
      tunaPieceProcess.tunaPieceKey = newKey;
      tunaPieceProcess.tunaPieceName = newTPName;

      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;

    }

    if (previousKey && !newKey) {
      tunaPieceProcess.tunaPieceKey = '';
      tunaPieceProcess.tunaPieceName = '';
      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;
    }

    const newTP = this.tunaPiecesMap.get(newKey) || {} as Cage;
    const newTPName = newTP.name;
        
    tunaPieceProcess.tunaPieceKey = newKey;
    tunaPieceProcess.tunaPieceName = newTPName;
    this.tunaPieceProcessService.update(tunaPieceProcess);
    return true;
  }

  displayCageName(key : string): string {
    if (this.cagesMap.has(key)) {
      return this.cagesMap.get(key)?.name || '';
    }
    return '';
  }

  onChangeFridge(tunaPieceProcess: TunaPieceProcess, tunaPieceProcessFridgeKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = tunaPieceProcessFridgeKey;
    // console.log('new key wanted',  newKey);
    // console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {

      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {

      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newFridge = this.fridgesMap.get(newKey) || {} as Fridge;
      const newFridgeName = newFridge.name;
        
      tunaPieceProcess.fridgeKey = newKey;
      tunaPieceProcess.fridgeName = newFridgeName;

      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;

    }

    if (previousKey && !newKey) {
      tunaPieceProcess.fridgeKey = '';
      tunaPieceProcess.fridgeName = '';

      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;
    }

    const newFridge = this.fridgesMap.get(newKey) || {} as Fridge;
    const newFridgeName = newFridge.name;
        
    tunaPieceProcess.fridgeKey = newKey;
    tunaPieceProcess.fridgeName = newFridgeName;
    this.tunaPieceProcessService.update(tunaPieceProcess);
    return true;
  }

  onChangeCustomer(tunaPieceProcess: TunaPieceProcess, tunaPieceProcessCustomerKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = tunaPieceProcessCustomerKey;
    // console.log('new key wanted',  newKey);
    // console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {

      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {

      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newCustomer = this.clientsMap.get(newKey) || {} as Client;
      const newCustomerName = newCustomer.companyName;
        
      tunaPieceProcess.customerKey = newKey;
      tunaPieceProcess.customerName = newCustomerName;

      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;

    }

    if (previousKey && !newKey) {
      tunaPieceProcess.customerKey = '';
      tunaPieceProcess.customerName = '';
   
      this.tunaPieceProcessService.update(tunaPieceProcess);
      return true;
    }

    const newCustomer = this.clientsMap.get(newKey) || {} as Client;
      const newCustomerName = newCustomer.companyName;
        
      tunaPieceProcess.customerKey = newKey;
      tunaPieceProcess.customerName = newCustomerName;
    this.tunaPieceProcessService.update(tunaPieceProcess);
    return true;
  }

  moveToFridge(tunaPieceProcess: TunaPieceProcess) {
    // this.tunaPieceProcess = {...tunaPieceProcess};
    // this.tunaPieceProcessDialog = true;
    this.openMove(tunaPieceProcess)
    this.moveDialog = true;
    //this.confirm({} as Event, []);

  }
  
  
  confirm(event: Event, items : any[]) {
    this.confirmationService.confirm({
        target: event.target || {} as EventTarget,
        header: 'Confirmation',
        // message: 'Are you moving the entire product?',
        // icon: 'pi pi-exclamation-triangle',
        accept: () => {
            //confirm action
        },
        reject: () => {
            //reject action
        }
    });
  }

  getInvoicedAmount() {
    let total = 0;
    this.tunaPieceProcesses.forEach( p => {
      if (p.customerIsInvoiced && p.customerUnitPrice && p.fishNumber  ) {
        total += p.customerUnitPrice * ( p.fishNumber - (p.fishMortality ||0 ) );
      }
    } );
    return total;
  }

  getNotInvoicedAmount() {
    let total = 0;
    this.tunaPieceProcesses.forEach( p => {
      if (!p.customerIsInvoiced && p.customerUnitPrice && p.fishNumber  ) {
        total += p.customerUnitPrice * ( p.fishNumber - (p.fishMortality ||0 ) );
      }
    } );
    return total;
  }

  getCountByStatus() {
    let total = 0;
    this.tunaPieceProcesses.forEach( p => {
      if (p.customerIsInvoiced && p.customerUnitPrice && p.fishNumber  ) {
        total += p.customerUnitPrice * ( p.fishNumber - (p.fishMortality ||0 ) );
      }
    } );
    return total;
  }

}
